// CSV headers for the promo code export (keys match the getExport API response)
export const exportHeaders = [
    { label: "Promo Code", key: "promo_code" },
    { label: "Description", key: "promo_description" },
    { label: "Plan", key: "plan" },
    { label: "Trial Period", key: "trial_period" },
    { label: "Discounted Price", key: "discounted_price" },
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "One Year Application", key: "one_year_application" },
    { label: "Status", key: "status" },
    { label: "Created On", key: "created_at" },
    { label: "Created By", key: "email" },
  ];